import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { isCheckListFilter } from '../../classes/column-filters/check-list/check-list-filter.class';
import { isDateRangeFilter } from '../../classes/column-filters/date-range/date-range-filter.class';
import { isRadioButtonFilter } from '../../classes/column-filters/radio-button/radio-button-filter.class';
import { isYearFilter } from '../../classes/column-filters/year/year-filter.class';
import { Filter } from '../../classes/filter.abstract';
import { isSelectFilter } from '../../classes/table-filters/select-filter.class';

let nextContext = 0;

@Component({
    selector: 'app-table-column-filter',
    templateUrl: './column-filter.template.html',
    styleUrls: ['./column-filter.style.scss'],
    imports: [PlatformModule, FormsModule, TranslateModule],
    standalone: true,
})
export class ColumnFilterComponent {
    @Input() filter!: Filter;
    context = `column-filter-${(nextContext += 1)}`;
    isDateRangeFilter = isDateRangeFilter;
    isCheckListFilter = isCheckListFilter;
    isYearFilter = isYearFilter;
    isSelectFilter = isSelectFilter;
    isRadioButtonFilter = isRadioButtonFilter;
}
